<template>
  <Loader v-if="loading"></Loader>
  <template v-else>
    <Header></Header>
    <Sidebar></Sidebar>
    <div class="xpage sc-page opal-page">
      <slot></slot>
    </div>
    <modal></modal>
  </template>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import Loader from "@/components/Loader.vue";
import Header from "@/components/layout/Header.vue";
import Sidebar from "@/components/search-page/Sidebar.vue";
import store from "@/store";
import modal from "@/components/Modal.vue";
import { RootStore } from "@/types/root-store";

const loading = ref<boolean>(true);

onMounted(async () => {
  loading.value = false;
  (store.state as RootStore).mobileMenu = false;
});
</script>

<style scoped>
div.xpage {
  margin-left: var(--xsidebar-width);
}

.sc-page {
  position: static;
  margin-left: var(--xsidebar-width);
  width: auto;
}

@media screen and (max-width: 960px) {
	div.xpage {
		margin-left: 0 !important;
	}
	
  .sc-page {
    margin-left: 0 !important;
    margin-top: 0;
  }
}
</style>
